<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png" /> -->
    <home></home>
    <!-- <fwz msg="Welcome to Your Vue.js App"/> -->
  </div>
</template>

<script>
import home from "./view/home";

export default {
  name: "app",
  components: {
    home,
  },
};
</script>

<style>
#app {
  /* font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 20px;
  margin-left: 20px; */
}

html {
  /* -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%; */
  -ms-text-size-adjust: none;
  -webkit-text-size-adjust: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -moz-tap-highlight-color: rgba(0, 0, 0, 0);
}

body {
  /* font-family: Helvetica, STHeiti STXihei, Microsoft JhengHei, Microsoft YaHei,
    Arial; */
  margin: 0;
  background-color: #F2F6FE;
  height: 100%;
/*  overflow-y: scroll;*/
/*  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  margin: 0 auto;
  min-height: 100%;*/
  /* background:#E02020; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue